export default __webpack_public_path__ + "static/media/stream-offline.74f25518.png";